import tankImg from 'Images/PC_oiltank.png';

export default {
  name: 'tankImage',
  template:
      `<div class="tank">
        <div class="tank-area">
          <div
            class="tank-div tank-oil bg-warning"
            ng-mouseover="TankImgCtrl.mouseEnterLeaveAction('oilHover')"
            ng-mouseleave="TankImgCtrl.mouseEnterLeaveAction('oilHover')"
            ng-style="{bottom: TankImgCtrl.percentWater+'%', height: TankImgCtrl.percentOil+'%'}">
          </div>
          <div
            class="tank-div tank-water bg-primary"
            ng-mouseover="TankImgCtrl.mouseEnterLeaveAction('waterHover')"
            ng-mouseleave="TankImgCtrl.mouseEnterLeaveAction('waterHover')"
            ng-style="{height: TankImgCtrl.percentWater+'%'}">
          </div>
        </div>
        <img src="${tankImg}" class="tank-img">
      </div>`,
  controllerAs: 'TankImgCtrl',
  bindings: {
    percentWater: '<',
    percentOil: '<',
    mouseEnterLeaveAction: '<?'
  }
};
